import { css } from '@emotion/core'

export const styles = {
  container: css`
    position: relative;

    width: 100vw;
    height: 70px;
    padding: 0 15px;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;

    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03), 0 10px 7px rgba(0, 0, 0, 0.02);
    background: rgba(255, 255, 255, 0.97);
    color: #777777;
    z-index: 100;

    user-select: none;
  `,

  section: css`
    display: flex;
    align-items: stretch;
  `,

  item: css`
    display: flex;
    align-items: center;
    position: relative;

    padding: 0 1vw;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    color: #6f828f;
    * {
      color: #6f828f;
    }

    cursor: pointer;
    transition: 300ms;

    border-bottom: 3px solid transparent;
    border-top: 3px solid transparent;

    &:hover {
      color: black;
      transition: 300ms;
    }

    & .active {
      background: red;
    }
  `,

  marker: css`
    position: absolute;

    top: 13px;
    right: 6px;

    padding: 6px;
    height: 16px;
    border-radius: 8px;

    /* background: rgb(58, 137, 196); */
    background: #ff5252;
    font-size: 9px;
    color: white;

    display: flex;
    align-items: center;
    justify-content: center;
  `,

  title: {
    container: css`
      font-size: 24px;
      cursor: pointer;

      & * {
        font-family: 'Comfortaa', cursive !important;
      }

      margin: 0 0 2px 0;
    `,

    name: css`
      color: #22303d;
    `,

    ext: css`
      color: #3a89c4;
    `,
  },

  button: css`
    border-bottom: 3px solid transparent;
    border-top: 3px solid transparent;

    & > span {
      color: rgb(58, 137, 196);
      font-weight: 600;
    }

    & > img {
      width: 20px;
      height: 20px;

      margin-right: 10px;
      margin-left: -8px;
    }

    &:hover {
      border-bottom: 3px solid rgb(58, 137, 196);
    }
  `,

  separator: css`
    width: 1px;
    height: 25px;

    align-self: center;
    background: rgb(230, 230, 230);

    margin: 0 15px;
  `,

  avatar: css`
    width: 30px;
    height: 30px;

    margin-right: 15px;
    margin-left: -6px;

    background: rgb(252, 252, 252);
    border: 1px solid rgb(200, 200, 200);
    border-radius: 15px;

    display: flex;
    align-items: center;
    justify-content: center;
  `,

  menuItem: css`
    height: 40px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    box-shadow: 0 0 1px 0 rgb(230, 230, 230);
    text-decoration: none;
    cursor: pointer;
    & > img {
      width: 16px;
      height: 16px;
    }
    & > span {
      margin-left: 10px;
      font-size: 13px;
      font-weight: 600;
      transition: 400ms;
    }
    &:hover {
      & > span {
        transition: 200ms;
        color: rgb(50, 50, 50);
      }
    }
  `,
}
